import React from 'react';
import { Link } from 'react-router-dom';

const AppFooter = () => {
  return (
    <footer className="w-full py-6 px-4 mt-auto">
      <div className="max-w-3xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-6 text-xs" style={{ color: '#9AA5A6' }}>
        <Link to="/terms" className="hover:underline" data-testid="footer-terms-link">Terms of Service</Link>
        <span className="hidden sm:inline">|</span>
        <Link to="/privacy" className="hover:underline" data-testid="footer-privacy-link">Privacy Policy</Link>
        <span className="hidden sm:inline">|</span>
        <a href="mailto:hello@ourloveconnection.co" className="hover:underline" data-testid="footer-contact-link">Contact: hello@ourloveconnection.co</a>
      </div>
    </footer>
  );
};

export default AppFooter;
